module.exports = "//static.hsappstatic.net/collaboration-sidebar/static-1.8167/images/CommentIndicatorPointer.svg"